import React from 'react';
import { Text } from 'components/text';

const ErrorLabel = props => <Text color="red.5" fontSize={1} {...props} />;

export default ErrorLabel;
